import React from "react";
import { Box } from "@chakra-ui/react";

/**
 * Logo personalizable.
 * Reemplaza /tzu.png con tu logo colocando el archivo en
 * saas/tzu-frontend/overrides/logo.png — se copia automáticamente
 * al build de Docker.
 *
 * Para cambiar el texto o color, edita este archivo en
 * saas/tzu-frontend/overrides/components/Logo.jsx
 */
const Logo = ({ size = '64px', cropScale = 1.45, imageFilter = 'none' }) => {
  return (
    <Box
      className="logo-container"
      boxSize={size}
      overflow="hidden"
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexShrink={0}
    >
      <img
        className="header_image"
        src="/logo.png"
        alt="ThreatModeling.studio Logo"
        style={{
          width: "100%",
          height: "100%",
          display: "block",
          objectFit: "contain",
          transform: `scale(${cropScale})`,
          transformOrigin: "center",
          filter: imageFilter,
        }}
        onError={(e) => {
          // Fallback al logo original si no se proporciona uno personalizado
          e.currentTarget.src = "/tzu.png";
        }}
      />
    </Box>
  );
};

export default Logo;
